import { render, staticRenderFns } from "./footer-p.vue?vue&type=template&id=49f0de30&scoped=true&"
import script from "./footer-p.vue?vue&type=script&lang=js&"
export * from "./footer-p.vue?vue&type=script&lang=js&"
import style0 from "./footer-p.vue?vue&type=style&index=0&id=49f0de30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0de30",
  null
  
)

export default component.exports